var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import { getErrorString, NOOP_LOGGER } from 'bernie-logger';
import { Store } from 'bernie-plugin-mobx';
import { observable } from 'mobx';
import { inject } from 'mobx-react';
import { STORE_EVENTS } from './store-events';
export var TRIP_CREATION_ERROR_CODES;
(function (TRIP_CREATION_ERROR_CODES) {
  TRIP_CREATION_ERROR_CODES[TRIP_CREATION_ERROR_CODES["INVENTORY_OOS"] = 0] = "INVENTORY_OOS";
  TRIP_CREATION_ERROR_CODES[TRIP_CREATION_ERROR_CODES["BOOKING_ERROR"] = 1] = "BOOKING_ERROR";
})(TRIP_CREATION_ERROR_CODES || (TRIP_CREATION_ERROR_CODES = {}));
inject('activityDetailStore');
var TripCreationStore = /** @class */function (_super) {
  __extends(TripCreationStore, _super);
  function TripCreationStore(state, logger) {
    if (state === void 0) {
      state = {};
    }
    if (logger === void 0) {
      logger = NOOP_LOGGER;
    }
    var _this = _super.call(this, state, logger) || this;
    _this.offerNotAvailableErrors = observable.map({});
    _this.createTripV2 = _this.createTripV2.bind(_this);
    return _this;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, class-methods-use-this
  TripCreationStore.prototype.hydrate = function (_data) {
    // Do nothing
  };
  TripCreationStore.prototype.createTripV2 = function (tripRequest) {
    var _this = this;
    return fetch('/LXCreateTrip', {
      method: 'POST',
      body: tripRequest,
      headers: {
        // eslint-disable-next-line quote-props
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      var errorCode = -1;
      if (data.tripid) {
        window.location.href = "/MultiItemCheckout?tripid=".concat(data.tripid);
      }
      if (data.errors) {
        data.errors.forEach(function (errorInfo) {
          errorInfo.errors.forEach(function (errorDetailInfo) {
            var descriptionText = JSON.stringify(errorDetailInfo.description);
            if (descriptionText.indexOf('9003 Unable to create product due to lack of inventory') > 0) {
              errorCode = TRIP_CREATION_ERROR_CODES.INVENTORY_OOS;
            } else {
              errorCode = TRIP_CREATION_ERROR_CODES.BOOKING_ERROR;
            }
            _this.logger.logEvent(STORE_EVENTS.TRIP_ID_NOT_RETURNED, tripRequest, descriptionText);
          });
        });
      }
      return errorCode;
    }).catch(function (error) {
      _this.logger.logEvent(STORE_EVENTS.CREATE_TRIP_FAILURE, tripRequest, getErrorString(error));
    });
  };
  return TripCreationStore;
}(Store);
export { TripCreationStore };